import React, { useEffect, useState } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../../env";
import CircularProgressBar from "../../../../../Common/ProgressBar/CircularProgressBar";

const NoticeAdminDashboard = () => {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    NoticeID: 0,
    NoticeDate: "",
    LetterNo: "",
    Headline: "",
    HeadlineUrl: "",
    IsActive: true,
  });

  const [file, setFile] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);

  useEffect(() => {
    fetchNotices();
  }, []);

  // ================= FETCH =================
  async function fetchNotices() {
    setLoading(true);
    try {
      const res = await axios.get(
        `${REACT_APP_API_URL}api/notice/all-notice`
      );
      setNotices(res.data || []);
    } catch (err) {
      console.error("Fetch error:", err);
      setNotices([]);
    } finally {
      setLoading(false);
    }
  }

  // ================= OPEN ADD =================
  function openAdd() {
    setForm({
      NoticeID: 0,
      NoticeDate: new Date().toISOString().slice(0, 10),
      LetterNo: "",
      Headline: "",
      HeadlineUrl: "",
      IsActive: true,
    });
    setFile(null);
    setUploadProgress(0);
    setIsUploading(false);
    setShowModal(true);
  }

  // ================= OPEN EDIT =================
  function openEdit(n) {
    setForm({
      NoticeID: n.NoticeID,
      NoticeDate: n.NoticeDate ? n.NoticeDate.split("T")[0] : "",
      LetterNo: n.LetterNo || "",
      Headline: n.Headline || "",
      HeadlineUrl: n.HeadlineUrl || "",
      IsActive: !!n.IsActive,
    });
    setFile(null);
    setUploadProgress(0);
    setIsUploading(false);
    setShowModal(true);
  }

  // ================= SUBMIT =================
  async function handleSubmit(e) {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("NoticeID", form.NoticeID || 0);
      formData.append("NoticeDate", form.NoticeDate);
      formData.append("LetterNo", form.LetterNo);
      formData.append("Headline", form.Headline);
      formData.append("HeadlineUrl", form.HeadlineUrl);
      formData.append("IsActive", form.IsActive ? "true" : "false");
      if (file && file.length > 0) {
  for (let i = 0; i < file.length; i++) {
    formData.append("files", file[i]);
  }
}

      setIsUploading(true);
      setUploadProgress(0);

      const isEdit = Number(form.NoticeID) > 0;

      await axios({
        method: isEdit ? "put" : "post",
        url: isEdit
          ? `${REACT_APP_API_URL}api/notice/update`
          : `${REACT_APP_API_URL}api/notice/upload`,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (e) => {
          if (!e.total) return;
          const percent = Math.round((e.loaded * 100) / e.total);
          setUploadProgress(percent);
        },
      });

      setIsUploading(false);
      setShowModal(false);
      fetchNotices();
    } catch (err) {
      console.error("Save error:", err);
      alert(err?.response?.data?.error || "Upload failed");
      setIsUploading(false);
    }
  }

  // ================= DELETE =================
  async function handleDelete(id) {
    if (!window.confirm("Delete this notice?")) return;
    try {
      await axios.delete(
        `${REACT_APP_API_URL}api/notice/delete/${id}`
      );
      fetchNotices();
    } catch (err) {
      console.error("Delete error:", err);
      alert("Delete failed");
    }
  }

  // ================= FILE URL =================
  const getFileUrl = (filePath) => {
    if (!filePath) return null;
    return `${REACT_APP_API_URL.replace(/\/$/, "")}${filePath}`;
  };

  // ================= RENDER =================
  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Notice Dashboard</h3>
        <button className="btn btn-primary" onClick={openAdd}>
          Add Notice
        </button>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered align-middle">
            <thead className="table-light">
              <tr>
                <th>Date</th>
                <th>Letter No</th>
                <th>Headline</th>
                <th>PDF</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {notices.length === 0 && (
                <tr>
                  <td colSpan="5" className="text-center">
                    No notices found
                  </td>
                </tr>
              )}

              {notices.map((n) => (
                <tr key={n.NoticeID}>
                  <td>{n.NoticeDate?.slice(0, 10)}</td>
                  <td>{n.LetterNo}</td>
                  <td>{n.Headline}</td>
                  <td>
                    {n.Files && n.Files.length > 0 ? (
                      n.Files.map((f, i) => (
                        <a
                          key={i}
                          href={getFileUrl(f.FilePath)}
                          target="_blank"
                          rel="noreferrer"
                          className="btn btn-sm btn-outline-primary me-1"
                        >
                          View {i + 1}
                        </a>
                      ))
                    ) : "-"}
                  </td>
                  <td>
                    <button
                      className="btn btn-sm btn-info me-2"
                      onClick={() => openEdit(n)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDelete(n.NoticeID)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* ================= MODAL ================= */}
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content" style={{ position: "relative" }}>
              <div className="modal-header">
                <h5 className="modal-title">
                  {form.NoticeID ? "Edit Notice" : "Add Notice"}
                </h5>
                <button
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                />
              </div>

              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-3 mb-2">
                      <label className="form-label">Notice Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={form.NoticeDate}
                        onChange={(e) =>
                          setForm({ ...form, NoticeDate: e.target.value })
                        }
                        required
                      />
                    </div>

                    <div className="col-md-3 mb-2">
                      <label className="form-label">Letter No</label>
                      <input
                        className="form-control"
                        value={form.LetterNo}
                        onChange={(e) =>
                          setForm({ ...form, LetterNo: e.target.value })
                        }
                      />
                    </div>

                    <div className="col-md-6 mb-2">
                      <label className="form-label">Headline</label>
                      <input
                        className="form-control"
                        value={form.Headline}
                        onChange={(e) =>
                          setForm({ ...form, Headline: e.target.value })
                        }
                        required
                      />
                    </div>

                    <div className="col-md-6 mb-2">
                      <label className="form-label">Upload PDF</label>
                      <input
                          type="file"
                          className="form-control"
                          accept=".pdf,.doc,.docx"
                          multiple
                          onChange={(e) => setFile(e.target.files)}
                        />
                      {form.NoticeID > 0 && (
                        <small className="text-muted">
                          Upload only to replace existing PDF
                        </small>
                      )}
                    </div>

                    <div className="col-md-3 mb-2">
                      <label className="form-label">Active</label>
                      <select
                        className="form-control"
                        value={form.IsActive ? "1" : "0"}
                        onChange={(e) =>
                          setForm({
                            ...form,
                            IsActive: e.target.value === "1",
                          })
                        }
                      >
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>

                  <div className="text-end mt-3">
                    <button
                      className="btn btn-success me-2"
                      type="submit"
                      disabled={isUploading}
                    >
                      {isUploading ? "Uploading..." : "Save"}
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </form>

                {isUploading && (
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      background: "rgba(255,255,255,0.9)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 10,
                    }}
                  >
                    <CircularProgressBar progress={uploadProgress} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NoticeAdminDashboard;
